import LegalPage, { LegalSection } from "./LegalPage";

const SECTIONS: LegalSection[] = [
  {
    heading: "Acceptance of Terms",
    body: (
      <p>
        By accessing or using the Oculera platform you agree to these Terms of Service. If you do
        not agree, please do not use the service.
      </p>
    ),
  },
  {
    heading: "Use of the Service",
    body: (
      <p>
        Oculera is intended for use by qualified eye care professionals and their authorized staff.
        You agree to use the service only for lawful purposes and in line with applicable
        regulations and your professional obligations.
      </p>
    ),
  },
  {
    heading: "Medical Disclaimer",
    body: (
      <p>
        Oculera supports clinical decision-making but does not replace professional medical
        judgment. Test results should always be interpreted by a qualified clinician in the context
        of the full clinical picture.
      </p>
    ),
  },
  {
    heading: "Accounts and Security",
    body: (
      <p>
        You are responsible for keeping your account credentials confidential and for all activity
        that occurs under your account. Notify us promptly of any unauthorized use. For the
        protection of patient data, sign-ins and access to patient records under your account are
        recorded in security audit logs as described in our <a href="/privacy">Privacy Policy</a>.
      </p>
    ),
  },
  {
    heading: "Intellectual Property",
    body: (
      <p>
        The Oculera software, content, and trademarks are owned by Oculera and its licensors. These
        Terms do not grant you any rights to our intellectual property except the limited right to
        use the service as intended.
      </p>
    ),
  },
  {
    heading: "Limitation of Liability",
    body: (
      <p>
        To the extent permitted by law, Oculera is not liable for indirect or consequential damages
        arising from your use of the service. The service is provided on an "as available" basis.
      </p>
    ),
  },
  {
    heading: "Changes to These Terms",
    body: (
      <p>
        We may update these Terms from time to time. Continued use of the service after changes take
        effect constitutes acceptance of the revised Terms.
      </p>
    ),
  },
];

export default function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="July 2026"
      intro="These Terms of Service govern your access to and use of the Oculera visual field testing platform and related services."
      sections={SECTIONS}
    />
  );
}
